import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative py-12 overflow-hidden" style={{ background: '#0a0a0a' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Logo & Social */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex items-center -my-3">
              <img src="/assets/images/logo.png" alt="SELTZ" className="h-20 w-auto object-contain invert brightness-0" />
            </Link>
            <div className="flex gap-4 mt-2">
              <a
                href="https://www.instagram.com/drinkseltz/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/drinkseltz/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://twitter.com/drinkseltz"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
            </div>
            <p className="text-white/50 text-xs" style={{ fontFamily: 'Nunito, sans-serif' }}>
              @drinkseltz
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-white font-black italic text-sm mb-4 uppercase tracking-widest" style={{ fontFamily: 'Nunito, sans-serif' }}>
              descoperă
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'povestea noastră', to: '/about' },
                { label: 'toate aromele', to: '/shop' },
                { label: 'contact', to: '/contact' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-white/70 hover:text-white text-sm font-semibold transition-colors"
                    style={{ fontFamily: 'Nunito, sans-serif' }}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-black italic text-sm mb-4 uppercase tracking-widest" style={{ fontFamily: 'Nunito, sans-serif' }}>
              legal
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'termeni și condiții', to: '/terms' },
                { label: 'politica de confidențialitate', to: '/privacy' },
                { label: 'contactează-ne', to: '/contact' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-white/70 hover:text-white text-sm font-semibold transition-colors"
                    style={{ fontFamily: 'Nunito, sans-serif' }}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs text-center leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif' }}>
            Consumați cu moderație. © {new Date().getFullYear()} Seltz™ Premium Vodka Soda, 5% Alc. by Vol.
          </p>
          <div className="flex gap-4">
            <Link to="/terms" className="text-white/40 hover:text-white/70 text-xs transition-colors" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Termeni
            </Link>
            <Link to="/privacy" className="text-white/40 hover:text-white/70 text-xs transition-colors" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Confidențialitate
            </Link>
            <Link to="/contact" className="text-white/40 hover:text-white/70 text-xs transition-colors" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
